module.exports = __webpack_public_path__ + "static/media/d3b.2f5d5501.png";